import LotsSidePanel from './lots-side-panel'

export default LotsSidePanel
